import { CmsList, CmsEdit, CmsCreate } from './pages';
import Paths from './paths';
import { default as Translations } from './lang/hu';

export default {
    pages: {
        CmsList,
        CmsEdit,
        CmsCreate,
    },
    paths: {
        ...Paths,
    },
    translations: {
        ...Translations,
    },
    name: 'cms',
    icon: 'fa-newspaper',
};

export { default as Paths } from './paths';



// WEBPACK FOOTER //
// ./src/modules/Cms/index.ts